import { useContext } from 'react';

import { UserContext, UserContextValue } from '../contexts/UserContext';

export const useUserInfo = (): UserContextValue => useContext(UserContext);
